import { BFFAgent } from 'BFFAgent'
import { put, call } from 'redux-saga/effects'
import {
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_FAILURE,
  STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN
} from '../constants'

export function* dispatchActionSaga({ data: { id, actionCode, fields } }) {
  try {
    const responseUpdateStateMachine = yield call(
      BFFAgent.Stock.TakingCarManagement.dispatchAction,
      id,
      actionCode,
      false,
      fields,
    )

    if (responseUpdateStateMachine) {
      yield put({
        type: STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_SUCCESS,
        data: responseUpdateStateMachine
      })

      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
        data: {takingCarId: id}
      })
      
    }
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGMENT_UPDATE_STATE_MACHINE_FAILURE,
      data: { error }
    })
  }
}
